import * as spring from 'react-spring';
import { prefersReducedMotion } from './prefers-reduced-motion';
import { merge } from 'lodash';
export var animated = spring.animated;
export function useTransition(items, options) {
  return spring.useTransition(items, merge({}, options, prefersReducedMotion ? {
    immediate: true
  } : {}));
}
export function useSpring(options) {
  return spring.useSpring(merge({}, options, prefersReducedMotion ? {
    immediate: true
  } : {}));
}